import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
const Index = (props) => {
  const dispatch = useDispatch()
  
  const [isShow, setisShow] = useState(0);
    useEffect(() => {
      if(props?.show!=null){
        if(props.show==true){
          setisShow(1);
        }else{
          setisShow(2);
        }
      
      }
      return () => {
        
      };
    }, [props.show]);
  return (
    <>
     <div className={`overlay-modal modal-custom ${isShow==1?"show":isShow === 2?"hide":""}`} onClick={()=>{props?.setHide(false)}}></div>
    <div className={`w-100  d-flex flex-column justify-content-between align-items-center modal-custom   radius-tl-16 radius-tr-16 ${isShow==1?"show":isShow === 2?"hide":""}`} >
     
        <div className='w-100 d-flex justify-content-end align-items-start mt-4'>
            <button className='bg-unset border-unset scale_btn' onClick={()=>{props?.setHide(false)}}>
              <div className='card-icon me-2' style={{ width:"20px",height:"20px" }}>
              <i class="fas fa-times text-white"></i> 
              </div>
            </button>
        </div>

        <div className='w-100 h-100  d-flex justify-content-end align-items-end'>
              {props?.children}
        </div>
    </div>
    </>
  )
}

export default Index;
